import { Box, Stack, Typography } from "@mui/material";

export default function Team() {
  return (
    <Stack direction="row" bgcolor="#F4F8FF" p={8} mt={5}>
      <Stack width={400}>
        <Typography variant="h3" fontWeight="bold" color="#20487E">
          Ons team
        </Typography>

        <Typography fontSize="18px" color="#888" mt={5} fontWeight={500}>
          Ontmoet ons team, bestaande uit vier creatieve CMD-studenten en twee innovatieve
          CMGT-studenten. Samen vormen we een dynamisch team dat klaar staat om unieke oplossingen
          te bedenken en creatieve projecten tot leven te brengen. Met onze diverse achtergronden en
          vaardigheden zijn we klaar om uitdagingen aan te gaan en succes te behalen in alles wat we
          doen.
        </Typography>
      </Stack>

      <Box>
        <img
          src={require("../Assets/Images/team.webp")}
          alt="team"
          style={{ borderRadius: "5px", width: "80%" }}
        />
      </Box>
    </Stack>
  );
}
